import { Component } from 'react';

import { Row, Container, Col, Card } from 'react-bootstrap';

import './AboutPage.scss';

import originalrpm from '../images/originalrpm.png';
import rpmrewrite from '../images/rpm-rewrite.png';

class AboutPage extends Component {

    img(title, src, className) {
        return <Card className={`img-card ${className}`}>
            <Card.Header>
                <Card.Title>{title}</Card.Title>
            </Card.Header>
            <Card.Body>
                <img alt={title} src={src} />
            </Card.Body>
        </Card>
    }

    render() {
        return (
            <Container className="about-page">
                <Row>
                    <Col>
                        <h2 className="mb-4">About</h2>
                        {this.img("First release of Retro Puzzle Maker", originalrpm, "right")}
                        <p>
                            Retro Puzzle Maker is a tool meant to help you create new games you can play on your original NES console.
                            The tool aims to make it easy to make a simple game, and also give a starting place to hack the code for a more complex game.
                            It was always viewed as a present to the retro gaming community - the original project codename was "happy-holidays". 
                        </p>
                        <p>
                            In development since 2018, the tool has gone through numerous iterations to reach the point it's at today.
                            The first version was released on January 1st, 2019 - at this time it was actually a NES rom with a very small web wrapper around it.
                            The rom handled editing back then, and supported a whole 8 levels. It also let you export your levels from a console
                            using a qr code! Surprisingly enough, some people actually liked and encouraged this little project.
                        </p>
                        <p className="clearer">
                            The project laid dormant for a while, however as December hit in 2021, this project was revived. The project was
                            entirely rewritten using a React frontend and a reworked rom based on {" "}
                            <a target="_blank" rel="noreferrer" href="https://nes-starter-kit.nes.science">nes-starter-kit</a>. This time, it was 
                            designed to patch a rom with a known format, allowing for much more freedom. The initial version released in February 2022
                            supported 64 levels, 16 unique tiles, and unique title/credits screens. 
                        </p>
                        {this.img("Rewritten Retro Puzzle Maker", rpmrewrite, "left")}
                        <p>
                            This gained an actual following! By March of that year, the offline version of the tool was released. Multiple new
                            versions were released, adding on features like custom music, an undo button, and a few new blocks in time for Ludum Dare. 
                            The tool's author used it to build a game for the competition, and ended up faring pretty well! A major update came out in
                            October of the year, allowing things like HUD customiation, custom screens, and multiple new tile types.
                        </p>
                        <p>
                            The tool laid dormant until 2024, when peoples' interests were piqued with the tool. This led to the 1.5 feature update,
                            another major update that doubled the number of available tiles, added font and sfx customization, and even more new tiles.
                            Significant polish was also added to the tool with this release, including features like undo in the image and level editors. 
                        </p>
                        <p>
                            As the author, I hope this tool leads you to create fun things! Hopefully, this will allow you to experience the joy
                            of playing a game you made on your own NES console. Have fun!
                        </p>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default AboutPage;
